export const GET_PERSONAL_SUMMARY = 'GET_PERSONAL_SUMMARY';
